import type {TFunction} from "i18next";

export function tSafelistingSheetTitle(
  isEdit: boolean,
  t: TFunction<"safelisting">,
): string {
  return isEdit
    ? t("sheet.edit", {defaultValue: "Edit safelisting"})
    : t("sheet.create", {defaultValue: "Create safelisting"});
}

export function tSafelistingSelectVehicleToast(t: TFunction<"safelisting">): string {
  return t("toast.select_vehicle", {defaultValue: "Select a vehicle to continue."});
}

export function tSafelistingToastCreated(t: TFunction<"safelisting">): string {
  return t("toast.created", {defaultValue: "Safelisting created"});
}

export function tSafelistingToastUpdated(t: TFunction<"safelisting">): string {
  return t("toast.updated", {defaultValue: "Safelisting updated"});
}

export function tSafelistingAccountabilityValidateError(t: TFunction<"safelisting">): string {
  return t("toast.accountability_validate_error", {
    defaultValue: "We could not validate accountability for this household.",
  });
}

export function tSafelistingAccountabilityForbidden(t: TFunction<"safelisting">): string {
  return t("toast.accountability_forbidden", {
    defaultValue: "You do not have permission to view accountability for this vehicle.",
  });
}

export function tSafelistingAccountabilityNotFound(t: TFunction<"safelisting">): string {
  return t("toast.accountability_not_found", {
    defaultValue: "Accountability data was not found for the selected vehicle and household.",
  });
}

export function tSafelistingAccountabilityLoadFailed(t: TFunction<"safelisting">): string {
  return t("toast.accountability_load_failed", {
    defaultValue: "Failed to load accountability data.",
  });
}

export function tSafelistingToastDeleted(t: TFunction<"safelisting">): string {
  return t("toast.deleted", {defaultValue: "Safelisting deleted"});
}

export function tSafelistingToastCancelled(t: TFunction<"safelisting">): string {
  return t("toast.cancelled", {defaultValue: "Safelisting cancelled"});
}

export function tSafelistingToastDaysCancelled(t: TFunction<"safelisting">): string {
  return t("toast.days_cancelled", {defaultValue: "Selected days cancelled"});
}

export function tSafelistingToastAccountabilityCorrected(t: TFunction<"safelisting">): string {
  return t("toast.accountability_corrected", {defaultValue: "Accountability corrected"});
}

export function tSafelistingToastCancelDateConflict(t: TFunction<"safelisting">): string {
  return t("toast.cancel_date_conflict", {
    defaultValue:
      "This permit has started. Close and use Cancel again to pick remaining days.",
  });
}
